/**
 * The Organization class acts as the view object for the organization.
 */
const tbs_model_vo_MatchEntry = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_MatchEntry.prototype = {
    /* The view object name */
    name: 'match',
    /* The view object instance */
    view: {
        get: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: '',
            basePath: '',
            rule: {
            }
        },
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    /**
     * @private
     * Format the organization position field according to the given fields.
     */
}

module.exports = tbs_model_vo_MatchEntry